module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Esposizione-Fiera.da100f14.svg";